import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SortOrderType } from 'src/app/shared/types';

@Component({
  selector: 'app-sort-bars-icon',
  imports: [CommonModule],
  template: `
    <svg
      class="bar-graph-icon"
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 16 16"
      [ngClass]="{ asc: order === 'ASC', desc: order === 'DESC' }"
      aria-hidden="true">
      <rect class="bar bar-1" x="0" y="2" width="14" height="3" rx="1"></rect>
      <rect class="bar bar-2" x="0" y="7" width="14" height="3" rx="1"></rect>
      <rect class="bar bar-3" x="0" y="12" width="14" height="3" rx="1"></rect>
    </svg>
  `,
  styles: [
    `
      :host {
        display: inline-flex;
        line-height: 0;
      }

      .bar-graph-icon {
        display: inline-block;
        fill: currentColor;
      }

      .bar {
        transform-origin: left center;
        transition: transform 0.2s ease;
      }

      .bar-graph-icon.asc .bar-1 {
        transform: scaleX(0.4);
      }
      .bar-graph-icon.asc .bar-2 {
        transform: scaleX(0.65);
      }
      .bar-graph-icon.asc .bar-3 {
        transform: scaleX(1);
      }

      .bar-graph-icon.desc .bar-1 {
        transform: scaleX(1);
      }
      .bar-graph-icon.desc .bar-2 {
        transform: scaleX(0.65);
      }
      .bar-graph-icon.desc .bar-3 {
        transform: scaleX(0.4);
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SortBarsIconComponent {
  @Input() order: SortOrderType = 'DESC';
  @Input() width = 12;
  @Input() height = 12;
}
